export function dateToFormat() {
    let date = new Date()
    let year = date.getFullYear();
    let month = ("0" + (date.getMonth() + 1)).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);
    return year + "-" + month + "-" + day;
}

export function lastMonthToFormat(time) {
  if (!time) {
    throw new Error("函数参数错误");
  } else {
    let year = time.getFullYear();
    let month = time.getMonth();
    if (month) {
      return year + "-" + ("0" + month).slice(-2);
    } else {
      return year - 1 + "-" + "12";
    }
  }
}


export function dateFormat() {
  var date=new Date();
  var year=date.getFullYear();
  /* 在日期格式中，月份是从0开始的，因此要加0
   * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
   * */
  var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
  var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
  //var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
  //var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
  //var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
  // 拼接
  return year+"-"+month+"-"+day+" "+"00"+":"+"00"+":"+"00";
}

export function dateFormatName() {
  var date=new Date();
  var year=date.getFullYear();
  /* 在日期格式中，月份是从0开始的，因此要加0
   * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
   * */
  var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
  var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
  var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
  var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
  var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
  // 拼接
  return year+"-"+month+"-"+day+"-"+hours+"-"+minutes+"-"+seconds;
}


export function dateTimeMinutes(date) {
  if (!date) {
    return "----";
  } else {
    var d = new Date(date);
    var year = d.getFullYear();
    var month = ("0" + (d.getMonth() + 1)).slice(-2);
    var day = ("0" + d.getDate()).slice(-2);
    var hour = ("0" + d.getHours()).slice(-2);
    var minutes = ("0" + d.getMinutes()).slice(-2);
    return year + "-" + month + "-" + day + " " + hour + ":" + minutes;
  }
}
export function formatMinutes() {
  var d = new Date();
  // var day = ("0" + d.getDate()).slice(-2);
  var hour = ("0" + d.getHours()).slice(-2);
  var minutes = ("0" + d.getMinutes()).slice(-2);
  return hour + ":" + minutes + ":" + "00";
}

// 手机号效验规则
export function isvalidPhone(tel) {
  const reg = /^1\d{10}$/;
  return reg.test(tel);
}
